"use client";
import React, { useState } from "react";
import { useInfoProvider } from "../../context/InfoContext";

const About = () => {
  const { info } = useInfoProvider();
  const [activeTab, setActiveTab] = useState("commercial");

  const servicesData = {
    commercial: [
      "Hotel, Restaurant, Café, Resorts & Guest Houses",
      "Construction & Real Estate Firm",
      "Healthcare Center & Labs",
      "Railways and Roads",
      "IT & Technology",
      "Financial Institutions",
      "BPO",
      "Artist (Musician, Magician etc)",
      "Logistics & Warehousing",
      "Retail & Automobiles",
      "... and many more Industries We Serve!",
    ],
    domestic: ["Residential - 'Individual House'"],
    professionals: [
      "Laundry",
      "Painting",
      "Technicians",
      "Movers & Packers",
      "Doctors & Medicals",
      "Pest Controller",
      "Carpenters & Fabricators",
      "Necessary Material Suppliers (E.g. Milk, Vegetables etc.)",
      "Others (News Paper etc.)",
    ],
  };
  const stats = [
    {
      id: 1,
      value: "100+",
      label: "Total Partners",
      icon: "/static/image/order_1.webp",
    },
    {
      id: 2,
      value: "150+",
      label: "Active Users",
      icon: "/static/image/client.webp",
    },
    {
      id: 3,
      value: "100+",
      label: "Active Members",
      icon: "/static/image/members.webp",
    },
    {
      id: 4,
      value: "5+",
      label: "Years of Experience",
      icon: "/static/image/year_exp.webp",
    },
  ];

  return (
    <div className="w-full ">
      {/* About Section */}
      <section className="py-16 px-6 bg-gradient-to-b from-blue-50 to-indigo-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              About <span className="text-blue-600">GIGSAM</span>
            </h2>
            <div className="w-24 h-1 bg-blue-600 mx-auto"></div>
          </div>

          <div className="flex flex-col lg:flex-row gap-12 items-start">
            {/* Left Content - Image with Stats */}
            <div className="lg:w-1/2">
              <div className="relative rounded-2xl overflow-hidden shadow-xl mb-8">
                <img
                  src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80"
                  alt="Professional team at work"
                  className="w-full h-auto object-cover"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6">
                  <div className="flex items-center">
                    <div className="bg-white/20 backdrop-blur-sm p-3 rounded-full mr-4 border border-white/30">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-8 w-8 text-white"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                        />
                      </svg>
                    </div>
                    <div>
                      <h4 className="text-2xl font-bold text-white">500+</h4>
                      <p className="text-blue-100">Successful Placements</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Services Section */}
              <div className="bg-white p-6 rounded-2xl shadow-lg">
                <h3 className="text-xl font-bold text-blue-600 mb-4">
                  Our Platforms
                </h3>
                <div className="flex flex-col sm:flex-row gap-4">
                  <div className="bg-blue-50 p-4 rounded-lg flex-1">
                    <div className="flex items-center mb-2">
                      <div className="bg-blue-100 p-2 rounded-full mr-3">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6 text-blue-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                          />
                        </svg>
                      </div>
                      <h4 className="font-semibold text-gray-800">
                        PeopleFusionHR
                      </h4>
                    </div>
                    <p className="text-sm text-gray-600">
                      Full-time employment solutions
                    </p>
                  </div>
                  <div className="bg-indigo-50 p-4 rounded-lg flex-1">
                    <div className="flex items-center mb-2">
                      <div className="bg-indigo-100 p-2 rounded-full mr-3">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6 text-indigo-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
                          />
                        </svg>
                      </div>
                      <h4 className="font-semibold text-gray-800">Gigz App</h4>
                    </div>
                    <p className="text-sm text-gray-600">
                      Part-time services platform
                    </p>
                  </div>
                </div>
              </div>
              <div className="mt-6 flex flex-wrap gap-4">
                {/* <button className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg shadow-md transition duration-300 font-medium flex items-center">
                  Learn More
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 ml-2"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button> */}
                <a href={`tel:${info?.app_contact}`}>
                  <button className="border-2 border-blue-600 text-blue-600 hover:bg-blue-50 px-6 py-3 rounded-lg transition duration-300 font-medium flex items-center">
                    Contact Us
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 ml-2"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                    </svg>
                  </button>
                </a>
              </div>
            </div>

            {/* Right Content - Text and Services */}
            <div className="lg:w-1/2">
              <div className="bg-white p-8 rounded-2xl shadow-lg mb-8">
                <h3 className="text-2xl font-bold text-blue-600 mb-4">
                  Your Trusted Staffing Partner!
                </h3>
                <h4 className="text-xl font-semibold text-gray-800 mb-6">
                  Connecting Talent with Opportunity
                </h4>

                <div className="space-y-5 text-gray-700">
                  <p>
                    At{" "}
                    <span className="text-blue-600 font-semibold">GIGSAM</span>,
                    we bridge the gap between top talent and thriving
                    businesses. Whether you're an employer seeking skilled
                    professionals or a job seeker looking for the perfect
                    opportunity, we assist temporary, contract, and permanent
                    staffing solutions tailored to your needs.
                  </p>
                  <p>
                    What sets{" "}
                    <span className="text-blue-600 font-semibold">GIGSAM</span>{" "}
                    apart is our commitment to providing actual value to our
                    users & partners. Our dedication and quality are unrivaled
                    in the business. We're more than a service provider.
                  </p>
                  <p>
                    We care as much about our users' & partners' achievements as
                    we do about our own. Therefore, we share business
                    opportunities with them so they may benefit from our
                    partnership. Our Platform{" "}
                    <span className="text-blue-600 font-semibold">
                      PeopleFusionHR
                    </span>{" "}
                    assists in providing hiring support for full time employment
                    and{" "}
                    <span className="text-blue-600 font-semibold">
                      Gigz App
                    </span>{" "}
                    covers the part-time services for below given industries :
                  </p>
                </div>
              </div>

              {/* Services Tabs */}
              <div className="bg-white p-6 rounded-2xl shadow-lg">
                <div className="flex border-b border-gray-200 mb-6 overflow-x-auto">
                  <button
                    onClick={() => setActiveTab("commercial")}
                    className={`px-4 py-2 font-medium whitespace-nowrap ${
                      activeTab === "commercial"
                        ? "text-blue-600 border-b-2 border-blue-600"
                        : "text-gray-500 hover:text-blue-600"
                    }`}
                  >
                    Commercial Services
                  </button>
                  <button
                    onClick={() => setActiveTab("domestic")}
                    className={`px-4 py-2 font-medium whitespace-nowrap ${
                      activeTab === "domestic"
                        ? "text-blue-600 border-b-2 border-blue-600"
                        : "text-gray-500 hover:text-blue-600"
                    }`}
                  >
                    Domestic Services
                  </button>
                  <button
                    onClick={() => setActiveTab("professionals")}
                    className={`px-4 py-2 font-medium whitespace-nowrap ${
                      activeTab === "professionals"
                        ? "text-blue-600 border-b-2 border-blue-600"
                        : "text-gray-500 hover:text-blue-600"
                    }`}
                  >
                    Professionals & Vendors
                  </button>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {servicesData[activeTab].map((service, index) => (
                    <div key={index} className="flex items-start group">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className={`h-5 w-5 mr-2 mt-0.5 flex-shrink-0 ${
                          activeTab === "commercial"
                            ? "text-blue-500"
                            : activeTab === "domestic"
                            ? "text-green-500"
                            : "text-purple-500"
                        }`}
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <span className="text-gray-700 group-hover:text-blue-600 transition-colors">
                        {service}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row gap-12 items-center">
            <div className="md:w-1/2">
              <img
                src="https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80"
                alt="Employers finding talent"
                className="rounded-xl shadow-xl w-full"
              />
            </div>

            <div className="md:w-1/2">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                Find the Right Talent, Fast
              </h2>
              <p className="text-lg text-gray-600 mb-6">
                We understand that finding the right employees is critical to
                success. Our streamlined recruitment process ensures that you
                get qualified, reliable, and job-ready candidates across various
                industries.
              </p>

              <div className="bg-blue-50 p-6 rounded-xl mb-8">
                <h3 className="text-xl font-semibold text-blue-700 mb-4">
                  Why Choose GIGSAM?
                </h3>
                <ul className="space-y-3">
                  <li className="flex items-start">
                    <span className="text-green-500 mr-2">✅</span>
                    <span>
                      <strong>Speed & Efficiency</strong> – Get the right people
                      when you need them.
                    </span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-500 mr-2">✅</span>
                    <span>
                      <strong>Industry Expertise</strong> – We source candidates
                      from multiple sectors.
                    </span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-500 mr-2">✅</span>
                    <span>
                      <strong>Flexible Solutions</strong> – Temporary,
                      contract-to-hire, and direct placements.
                    </span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-500 mr-2">✅</span>
                    <span>
                      <strong>Vetted Professionals</strong> – We ensure skills,
                      experience, and cultural fit.
                    </span>
                  </li>
                </ul>
              </div>

              {/* <button className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg shadow-md transition duration-300">
                Post a Job Opening
              </button> */}
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row-reverse gap-12 items-center">
            <div className="md:w-1/2">
              <img
                src="https://images.unsplash.com/photo-1521791055366-0d553872125f?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80"
                alt="Job seekers finding opportunities"
                className="rounded-xl shadow-xl w-full"
              />
            </div>

            <div className="md:w-1/2">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                Your Next Opportunity Awaits
              </h2>
              <p className="text-lg text-gray-600 mb-6">
                Looking for work? Whether you need a short-term gig, freelance
                opportunity, or a full-time position, GIGSAM connects you with
                employers who are hiring now.
              </p>

              <div className="bg-indigo-50 p-6 rounded-xl mb-8">
                <h3 className="text-xl font-semibold text-indigo-700 mb-4">
                  Why Work with GIGSAM?
                </h3>
                <ul className="space-y-3">
                  <li className="flex items-start">
                    <span className="text-indigo-500 mr-2">✔</span>
                    <span>
                      <strong>Access to Exclusive Jobs</strong> – Get matched
                      with top companies.
                    </span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-indigo-500 mr-2">✔</span>
                    <span>
                      <strong>Flexible Work Options</strong> – Choose gigs,
                      part-time, or full-time roles.
                    </span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-indigo-500 mr-2">✔</span>
                    <span>
                      <strong>Quick & Easy Hiring Process</strong> – No long
                      waits, just fast placement.
                    </span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-indigo-500 mr-2">✔</span>
                    <span>
                      <strong>Support & Guidance</strong> – Resume tips, career
                      advice, and more.
                    </span>
                  </li>
                </ul>
              </div>

              {/* <div className="flex flex-wrap gap-4">
                <button className="bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-3 rounded-lg shadow-md transition duration-300">
                  Browse Jobs
                </button>
                <button className="border-2 border-indigo-600 text-indigo-600 hover:bg-indigo-50 px-6 py-3 rounded-lg transition duration-300">
                  Upload Resume
                </button>
              </div> */}
            </div>
          </div>
        </div>
      </section>

      <section
        className="relative discover_world_back bg-cover bg-center py-20 my-20"
        // style={{
        //   backgroundImage:
        //     "url('https://demo.websolutionus.com/aabcserv/uploads/website-images/counter-bg--2022-09-29-12-43-47-5215.jpg')",
        // }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-60"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 text-white text-center">
            {stats.map((stat) => (
              <div key={stat.id} className="flex flex-col items-center">
                <div className="size-28 bg-white rounded-full flex items-center justify-center shadow-lg">
                  <img src={stat.icon} alt={stat.label} className="w-12 h-12" />
                </div>
                <h3 className="text-3xl font-bold mt-4">{stat.value}</h3>
                <p className="text-lg">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
